<template>
  <div>
    <app-breadcrumb>
      <!-- <template #contentright>
                <b-button variant="success" :to="{ name: 'category-create' }">
                    <span class="text-nowrap">
                        <feather-icon icon="PlusCircleIcon" /> {{$t('Add New')}}
                    </span>
                </b-button>
            </template> -->
    </app-breadcrumb>
    <div class="row d-flex justify-content-center">
      <div class="col-md-8">
        <div class="card">
          <div class="card-body pt-0">
            <validation-observer
              #default="{ handleSubmit }"
              ref="refFormObserver"
            >
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent="handleSubmit(onSubmit)"
                @reset.prevent="resetForm"
              >
                <b-row>
                  <b-col cols="12">
                    <validation-provider
                      #default="validationContext"
                      name="Tên chuyên muc"
                      vid="name"
                      rules="required"
                    >
                      <b-form-group
                        label="Tên chuyên muc"
                        label-for="v-name"
                      >
                        <b-form-input
                          id="v-name"
                          v-model="frmData.name"
                          autofocus
                          :state="getValidationState(validationContext)"
                          placeholder="Tên chuyên muc"
                        />
                        <b-form-invalid-feedback> {{ validationContext.errors[0] }} </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      :label="$t('Chuyên mục cha')"
                      label-for="v-parent_id"
                    >
                      <v-select
                        v-model="frmData.parent_id"
                        :options="dataParent"
                        :reduce="(val) => val.code"
                        placeholder="--Chọn--"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group
                      :label="$t('Vị trí')"
                      label-for="v-position"
                    >
                      <b-form-input
                        id="v-position"
                        v-model="frmData.position"
                        :placeholder="$t('Sắp xếp')"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group>
                      <b-form-checkbox
                        id="v-status"
                        v-model="frmData.status"
                      > {{ $t('Kích hoạt') }} </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-button
                      type="submit"
                      variant="danger"
                      class="mr-1 mt-1"
                    >
                      <feather-icon icon="SaveIcon" /> {{ $t('Save') }} </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, email, alphaNum, min, max,
} from '@validations'
import {
  BCard, BAlert, BLink, BButton, BRow, BCol, BForm, BFormInput, BFormInvalidFeedback, BFormTextarea, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import store from '@/store'
import vSelect from 'vue-select'
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import { showToast } from '@core/utils/utils';

export default {
  components: {
    BCol,
    BRow,
    BButton,
    BCard,
    BAlert,
    BFormGroup,
    BForm,
    BFormInput,
    BFormCheckbox,
    BFormTextarea,
    BLink,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    AppBreadcrumb,
    vSelect,
  },
  data() {
    return {
      dataParent: [],
      dataContentType: [
        { label: 'Tin tức', code: 'news' },
        { label: 'Video', code: 'video' },
        { label: 'Autio', code: 'audio' },
        { label: 'Photo', code: 'photo' },
        { label: 'Infographic', code: 'infographic' },
        { label: 'Longform', code: 'longform' },
      ],
    }
  },
  setup(props, { emit }) {
    const frmData = ref({
      name: '',
      content_type: 'news',
      parent_id: '',
      style: 1,
      image: '',
      lang: 'vi',
      position: '',
      status: 0,
    })
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(frmData)
    const fetchAll = (ctx, callback) => {
      // console.log('fetchAll')
    }

    return {
      fetchAll,
      refFormObserver,
      getValidationState,
      resetForm,
      frmData,

    }
  },
  mounted() {
    this.getParent(this.frmData.content_type)
  },
  methods: {
    getParent(type = 'news') {
      store.dispatch('category/fetchAll', { type, style: 1 })
        .then(response => {
          const result = response.data
          if (result.code === 200) {
            this.dataParent = Array.isArray(result.data) ? result.data : [];
          }
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    onChangeContentType(event) {
      this.getParent(event.code)
    },
    onSubmit() {
      store.dispatch('category/create', this.frmData)
        .then(response => {
          const result = response.data;
          if (result.code === 200) {
            showToast(result.message, { variant: 'success' });
            this.$router.push({ name: 'category-list' })
          } else {
            showToast(result.message);
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
